import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cpf-insurance-details-page',
  templateUrl: './insurance-details-page.component.html',
  styleUrls: ['./insurance-details-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InsuranceDetailsPageComponent {

}
